// extracted by mini-css-extract-plugin
export default {"contentpdf":"stylepdf_contentpdf__uvwAE","containerzoom":"stylepdf_containerzoom__x3tj5","buttonFloatingUp":"stylepdf_buttonFloatingUp__Kf53H"};